import initAnalyticsHoverTracking from './analytics/hover-intent'

const publicAnalytics = {
    page: {
        init: () => {
            initAnalyticsHoverTracking('.trupath-hero-mini-card', 1000);
            initAnalyticsHoverTracking('.marketing-that-matters-mini-card', 1000);
            initAnalyticsHoverTracking('.trusupport-tools-mini-card', 1000);
        }
    }
}

const portalAnalytics = {
    page: {
        init: () => {
					initAnalyticsHoverTracking('.marketing-that-matters-mini-card', 1000);
					initAnalyticsHoverTracking('.marketing-branding-advertising-mini-card', 1000);
					initAnalyticsHoverTracking('.training-mini-card', 1000);
        }
    }
}

window.analytics = {
	public: publicAnalytics,
	portal: portalAnalytics
};
